import { RiErrorWarningFill } from "react-icons/ri"
import { colors } from '../../utilities/colors'
import { AccordionRoot, AccordionItem, AccordionItemContent, AccordionItemTrigger } from "../ui/accordion"

export default function InfoItem({title, data = null, subdata = null, editableTitle, children = null, alert=null}) {
  return (
    <div className="w-full p-1">
      <p className={`text-sm ${editableTitle ? 'text-grey-100' : 'text-grey-300'}`}>{title}</p>
      <div className="w-full flex items-center">
        {data &&
          <p className={`w-full text-md text-grey-100 flex items-center gap-2`}>
            {alert && <RiErrorWarningFill color={colors.yellow}/>}
            {data || ''}
          </p>
        }
      </div>
      {children && children}
      {subdata && <p className="text-md text-grey-100">{subdata !== null ? subdata : ''}</p>}
    </div>
  )
}

export function CollapsibleInfoItem({title, children = null, alert = null}) {
  return (
    <AccordionRoot
      type="single"
      collapsible
      p={1}
    >
      <AccordionItem>
        <AccordionItemTrigger className="w-fit" chevronOrientation="right">
          <p className='text-sm text-grey-300'>{title}</p>
        </AccordionItemTrigger>
        <AccordionItemContent>
          {children && children}
          {alert && <RiErrorWarningFill color={colors.yellow}/>}
        </AccordionItemContent>
      </AccordionItem>
    </AccordionRoot>
  )
}